import { render } from "./partnerTable.vue?vue&type=template&id=5755d3c1&scoped=true"
import script from "./partnerTable.vue?vue&type=script&lang=js"
export * from "./partnerTable.vue?vue&type=script&lang=js"

import "./partnerTable.vue?vue&type=style&index=0&id=5755d3c1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5755d3c1"]])

export default __exports__